// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import { ActionType, IAction, IActionControllerData } from "actions";
import { IDeviceInfoResponse } from "comtypes";
import { IStateController } from "states/controllerstates";
import { DataState } from "types";
import { isSet } from "utils";

export default function controllerReducer(
  state: IStateController | undefined,
  action: IAction<unknown>,
): IStateController | undefined {
  switch (action.type) {
    case ActionType.ACT_NAVIGATION:
      if (state) {
        state.dataState = DataState.EMPTY;
      }
      return state;

    case ActionType.ACT_GET_CONTROLLERDATA_SUCC: {
      const payload = action.payload as IActionControllerData;
      state = {
        ...state!,
        ...payload,
      };
      return state;
    }

    case ActionType.ACT_GET_DEVICEINFO_SUCC: {
      const payload = action.payload as IDeviceInfoResponse;
      if (!isSet(state)) {
        state = {
          dataState: DataState.EMPTY,
        };
      }
      state.serialNumber = payload.serial;
      state.unlockedUntil = payload.unlocked;
      return state;
    }

    case ActionType.ACT_SAVE_CONTROLLERDATA_REQ:
      state!.dataState = DataState.SAVE_REQ;
      return state;
    case ActionType.ACT_SAVE_CONTROLLERDATA_SUCC:
      state!.dataState = DataState.SAVE_SUCC;
      return state;
    case ActionType.ACT_SAVE_CONTROLLERDATA_FAIL:
      state!.dataState = DataState.SAVE_FAIL;
      return state;
    case ActionType.ACT_SAVE_CHARGER_POWER_RESET:
      state!.dataState = DataState.CLEAN;
      return state;

    default:
      return state;
  }
}
